import { IdleInterruptSourceEventTargetOptions } from './interrupt-source-event-target';
import { IdleInterruptSourceWindow } from './interrupt-source-window';

/**
 * An interrupt source on the storage event of Window.
 */
export class IdleInterruptSourceStorage extends IdleInterruptSourceWindow {
    private idleName = 'main';

    constructor(options: number | IdleInterruptSourceEventTargetOptions = 500, idleName?: string) {
        super('storage', options);

        this.idleName = idleName || 'main';
    }

    /**
     * Checks to see if the event should be filtered.
     * @param event - The original event object.
     * @return True if the event should be filtered (don't cause an interrupt); otherwise, false.
     */
    override filterEvent(event: StorageEvent): boolean {
        if (event.key && event.key.indexOf(this.idleName + '.') >= 0 && event.key.indexOf('.expiry') >= 0) {
            return false;
        }
        return true;
    }
}
